export default "__VITE_ASSET__BRbWHcBE__"